import {
	BankAccount,
	RegisterHostProfileV2Dto,
	FollowDto,
	HostNotificationMode,
} from "@onair/repositories";
import {
	doFollow,
	doUnfollow,
	hostRegisterV2,
	updateHostNotificationMode,
	upsertMultipleUserBankAccount,
	upsertUserBankAccount,
} from "@onair/services/user";
import { MutationOptions, useMutation } from "@tanstack/react-query";

const mutationUpsertUserBankAccount = () => {
	return useMutation({
		mutationFn: (bankAccount: BankAccount) => {
			return upsertUserBankAccount(bankAccount);
		},
	});
};

const mutationUpsertMultipleUserBankAccount = () => {
	return useMutation({
		mutationFn: (bankAccounts: BankAccount[]) => {
			return upsertMultipleUserBankAccount(bankAccounts);
		},
	});
};

const useMutationFollowUser = (options = {}) => {
	return useMutation({
		mutationFn: (params: FollowDto) => doFollow(params),
		...options,
	});
};

const useMutationUnfollowUser = (options = {}) => {
	return useMutation({
		mutationFn: (params: FollowDto) => doUnfollow(params),
		...options,
	});
};

const useMutationHostRegisterV2 = () => {
	return useMutation({
		mutationFn: (data: RegisterHostProfileV2Dto) => hostRegisterV2(data),
	});
};

const useUpdateHostNotificationModeMutation = () => {
	return useMutation({
		mutationFn: (mode: HostNotificationMode) => {
			return updateHostNotificationMode(mode);
		},
	});
};

export {
	mutationUpsertMultipleUserBankAccount,
	mutationUpsertUserBankAccount,
	useMutationFollowUser,
	useMutationUnfollowUser,
	useMutationHostRegisterV2,
	useUpdateHostNotificationModeMutation,
};
